import React, { Component } from 'react';
import config from 'react-global-configuration';
// Importação do Router
import InputMask from 'react-input-mask';
// Importação da tabela
import RequestApi from '../Miscelania/RequestApi';

import Overlay from '../Miscelania/Overlay';


class StaffRevisionDesignationEmail extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      message: '',
      iframe: 'iframe-hidden',
      url_export: null,
      staff_revision: {},
      staff_revision_designation_responsible: {},
    };
    // Handlers
    this.handleAlert = this.handleAlert.bind(this);

    this.loadData = this.loadData.bind(this);
    this.approveRequest = this.approveRequest.bind(this);
  }

  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  componentDidMount() {
    this.loadData();
  }

  loadData() {
    var headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    };
    this.handleAlert('', '', 'open');
    fetch(config.get('api') + '/revisao/designacao/colaborador/finalizar/'+this.props.match.params.id, { method: 'GET', mode: 'cors', headers: headers }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
      var url = config.get('cdn') + '/tmp/' + responseJson.data.url;
      this.setState({message: responseJson.message});
      this.setState({staff_revision_designation_responsible: responseJson.data.main});
      this.setState({date: responseJson.data.date});
      this.setState({staff_revision: responseJson.data.main.staff_revision});
      this.setState({iframe: 'iframe'});
      this.setState({url_export: url});
      this.handleAlert('', '', 'closed');
    }).catch((error) => {
      console.error(error);
    });
  }


  approveRequest(id) {
    this.handleAlert('', '', 'open');
    var headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    };
    var datasave = {
      date: this.state.date,
      id: this.props.match.params.id,
    };
    var self = this;
    fetch(config.get('api') + '/revisao/designacao/colaborador/aprovar', { method: 'PUT', mode: 'cors', headers: headers, body: JSON.stringify(datasave)}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
      var url = config.get('cdn') + '/tmp/' + responseJson.data.url;
      if (responseJson.status === 'success') {
        this.setState({staff_revision_designation_responsible: responseJson.data});
      }
      self.handleAlert(responseJson.message, responseJson.status, 'open');
    }).catch((error) => {
      console.error(error);
    });
  }
  render() {
    return (
<div className="user-wrapper" style={{backgroundImage: "url('" + config.get('cdn') + "/images/modal_background.png'), url('" + config.get('cdn') + "/images/fundo-login.jpg')"}}>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container">
    <div className="conteudo">
      {this.state.staff_revision_designation_responsible.status === "pendente" ?
        <div>
          <h4 className="page-tilte">Revisão {this.state.staff_revision.number}</h4>
          <hr/>
          <div className="row">
            <div className="col-md-6">
              <label>Data da resposta:</label>
              <InputMask value={this.state.date}  maskChar={null} name="date " mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date')} placeholder="Data da resposta" />
            </div>
            <div className="col-md-6">
              <button onClick={() => {this.approveRequest(this.state.staff_revision_designation_responsible.id)}} className="btn btn-inline btn-block btn-success"><i className="fa fa-fw fa-check"></i> Declaro que estou ciente da nova Revisão de Designação</button>
            </div>
          </div>
          <hr/>
          <iframe className={this.state.iframe} height="600px" width="100%" src={this.state.url_export} name="iframe_a"></iframe>
        </div>
        : <p>Link desatualizado, você já respondeu anteriormente</p>
      }
		</div>
  </div>
</div>
    );
  }
}

export default StaffRevisionDesignationEmail;



// WEBPACK FOOTER //
// ./src/Components/StaffRevisionDesignations/StaffRevisionDesignationEmail.js